"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _default = {
  appBar: 1000,
  drawer: 1100,
  dialog: 1200,
  dropdown: 1300,
  toast: 1400,
  tooltip: 1500
};
exports["default"] = _default;